import Action from '../base/action';

class MediaScreenCurrentTime extends Action {
    mediaId;
    currentTime;

    constructor(props) {
        super({...props, className: props.className || props.type + '_class'});
        this.mediaId = props.instanceId;
        this.currentTime = props.currentTime;
    }

    async execute({training}) {
        const media = MediaScreenManager.getMediaScreenFromInstanceId(this.mediaId);

        if (isNullOrUndefined(media)) {
            console.log('Media not found for id: ' + this.mediaId);
            return;
        }

        media.setVideoCurrentTime(this.currentTime);
    }
}

export default MediaScreenCurrentTime;
